import {
    OTHER_EMAILS,
    DISTRICT_REP_DETAILS
} from '../constants/Emails';

import EmailIcon from '../../img/email.svg';
import { useState } from 'react';



const Result = ({ selectedSchool }) => {

  const [copyButtonText, setCopyButtonText] = useState("Copy all emails to clipboard")

  return (
    <div id="results">

      <div id="emailResults" className='result-box'>
        <div id="districtInfo">
          <h1>{selectedSchool.schoolName}</h1>
          <p>Your school is in <b>District {selectedSchool.cecDistrict}</b></p>
          <p>Your CEC Rep is <b>{DISTRICT_REP_DETAILS[selectedSchool.cecDistrict].name}</b></p>
          <p><img className='icon' alt="Email icon" src={EmailIcon} /> <a href={`mailto:${DISTRICT_REP_DETAILS[selectedSchool.cecDistrict].email}`}>{DISTRICT_REP_DETAILS[selectedSchool.cecDistrict].email}</a></p>
        </div>
        <div id="otherEmails">
          <h2>Other Useful Emails</h2>
          {OTHER_EMAILS.map(person =>
            <p>{person.name} (<i>{person.position}</i>): <a href={`mailto:${person.email}`}>{person.email}</a></p>  
          )}
        </div>
        </div>
        <button
          onClick={() => {
            const emails = [
              DISTRICT_REP_DETAILS[selectedSchool.cecDistrict].email,
              ...OTHER_EMAILS.map(person => person.email)
            ];

            navigator.clipboard.writeText(emails.join(', '));
            setCopyButtonText("Copied to clipboard!")
            setTimeout(() => {
              setCopyButtonText("Copy all emails to clipboard")
            }, 2000)
            
          }}
        >{copyButtonText}</button>
        
    </div>
  )
}

export default Result;